import {isNotNil, sum} from 'ramda';

import {getSafely} from 'shared/web';

import {PriceMapChartItem} from '../types/PriceMapChartItem';

export function getAverageValueWithoutMyVehicle(
  key: 'x' | 'y',
  items: PriceMapChartItem[]
): number {
  const values = items
    .filter((item) => !item.car.isMyVehicle)
    .map((item) => getSafely(item, key))
    .filter(isNotNil);

  if (values.length === 0) {
    return 0;
  }

  return Math.round(sum(values) / values.length);
}
